import React, { useEffect, useRef } from 'react'
import { profileIconDefault } from '../../../assets/logos/icons';
import moment from "moment";
import { EffectFade, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from '@material-ui/core';
import './gridSemaforo-cells.css';

export const HeaderColumnOne = (props) => {
    return <span className='RepseGrid-cellOne-header'>{props.title}</span>;
}

export const CellColumnOne = (props) => {
    const { dataItem, field, showImage, onRowClick } = props;

    return (
        <td onClick={onRowClick ? () => onRowClick(dataItem) : null} className={`RepseGrid-cell ${dataItem.selected ? "selected" : ""}`}>
            <div className='RepseGrid-cellOne'>
                {
                    showImage && <img
                        alt="profile-img"
                        src={profileIconDefault}
                        className="RepseGrid-cellOne-avatar"
                    />
                }
                <div>
                    <p className='RepseGrid-cellOne-name'>{field ? dataItem[field] : dataItem.name}</p>
                </div>
            </div>
        </td>
    );
}

export const HeaderSemaforo = (props) => {
    const { showSwiper, swiperState, dataItem, onHeaderRowClick, showBinnacle } = props;
    const { currSlide, prevSlide, active } = swiperState;
    const swiperRef = useRef();
    console.log('dataItem', dataItem)
    // console.log('dataItem selectedValue', dataItem.selectionValue)
    const show4 = useMediaQuery("(max-width:720px)");
    const show3 = useMediaQuery("(max-width:580px)");
    const show2 = useMediaQuery("(max-width:450px)");
    const show1 = useMediaQuery("(max-width:380px)");

    let months = moment.monthsShort();

    useEffect(() => {
        if (!showSwiper || !active) return;
        setTimeout(() => {
            if (swiperRef.current.swiper) {
                swiperRef.current.swiper.slideTo(currSlide);
            };
        }, 10);
    }, [currSlide])

    if (showSwiper) {
        return (<div className="RepseGrid-semaforoHeader">
            <Swiper
                ref={swiperRef}
                modules={[EffectFade, Navigation]}
                spaceBetween={10}
                slidesPerView={show1 ? 1 : show2 ? 2 : show3 ? 3 : show4 ? 4 : 6}
                pagination={{
                    clickable: true,
                }}
                initialSlide={!active ? currSlide : prevSlide}
                centeredSlides={true}
                speed={150}
            >
                {months.map((month, i) => (
                    <SwiperSlide>
                        <div key={i} className="RepseGrid-semaforoHeader-month"
                        // onClick={() => console.log("tas haciendo clic>>>>>>>", month)} 
                        >
                            <p>{month}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>);
    }

    return (
        <div className="RepseGrid-semaforoHeader">
            {months.map((month, i) => (
                <div key={i} className="RepseGrid-semaforoHeader-month"
                    /*onClick={onHeaderRowClick ? () => onHeaderRowClick(months.indexOf(month) + 1, month) : null}*/ >
                    <p>{month}</p>
                </div>
            ))}
        </div>
    )
}

const CellSemaforoWrapper = (props) => {
    const { dataItem, onRowClick, showSwiper, swiperState, onSlideChange } = props;
    const { currSlide, prevSlide, touchedId, active } = swiperState;

    const show4 = useMediaQuery("(max-width:720px)");
    const show3 = useMediaQuery("(max-width:580px)");
    const show2 = useMediaQuery("(max-width:450px)");
    const show1 = useMediaQuery("(max-width:380px)");

    const swiperRef = useRef();

    let isTouched = false; // para detectar cuál slider se está arrastrando

    useEffect(() => {
        if (!showSwiper || !active) return;
        setTimeout(() => {
            if (swiperRef.current.swiper) {
                swiperRef.current.swiper.slideTo(currSlide);
            };
        }, 10);
    }, [currSlide])

    const touchStartHandler = () => isTouched = true;

    const activeIndexChangeHandler = (swiper) => {
        if (!isTouched) return;
        onSlideChange(swiper, dataItem.id);
    }

    if (showSwiper) {
        return (
            <td onClick={onRowClick ? () => onRowClick(dataItem) : null} className={`RepseGrid-cell RepseGrid-swiper ${dataItem.selected ? "selected" : ""}`}>
                <Swiper
                    ref={swiperRef}
                    modules={[EffectFade, Navigation]}
                    spaceBetween={10}
                    slidesPerView={show1 ? 1 : show2 ? 2 : show3 ? 3 : show4 ? 4 : 6}
                    pagination={{
                        clickable: true,
                    }}
                    initialSlide={touchedId == dataItem.id || !active ? currSlide : prevSlide}
                    onTouchStart={touchStartHandler}
                    onActiveIndexChange={activeIndexChangeHandler}
                    centeredSlides={true}
                    speed={150}
                >
                    {props.children}
                </Swiper>
            </td>
        )
    }

    return (
        <td onClick={onRowClick ? () => onRowClick(dataItem) : null} className={`RepseGrid-cell ${dataItem.selected ? "selected" : ""}`}>
            <div className='RepseGrid-semaforoCell'>
                {props.children}
            </div>
        </td>
    )
}

export const CellSemaforo = (props) => {
    const { dataItem, getColorByStatus, yearShown, showSwiper, onClick, clickableColors } = props;
    const compliance = Object.keys(dataItem.compliance || {}).length === 0 ? [] : dataItem.compliance;
    const clickableColorsAux = clickableColors || [];

    let months = moment.monthsShort();
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    return (
        <CellSemaforoWrapper {...props}>
            {
                months.map((_, index) => {
                    let isFutureMonth = false;
                    let representedMonth = new Date(yearShown, index, 1);
                    if (representedMonth >= firstDayOfMonth) isFutureMonth = true;

                    let status = compliance[index + 1] || "Sin validar";
                    let color = getColorByStatus(status);

                    let clickable = clickableColorsAux.includes(color);

                    let circle = <div className={`RepseGrid-semaforoCell-item ${onClick && clickable ? "clickable" : ""}`} key={index} onClick={onClick && clickable ? () => onClick(dataItem, index) : null}>
                        <div className={`RepseGrid-semaforoCell-circle ${color}`}></div>
                    </div>

                    if (showSwiper) {
                        return (
                            <SwiperSlide>
                                {circle}
                            </SwiperSlide>
                        )
                    }

                    return circle;
                })
            }
        </CellSemaforoWrapper>
    )
}
